import { from } from "rxjs";
import { createActionTypeModel } from "../../../../store/global/action-model";

export const Templates = createActionTypeModel('Templates');
export const SelectedBookingTemplate = createActionTypeModel('SelectedBookingTemplate');
export const TemplateDetails = createActionTypeModel('TemplateDetails');
